/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EodMelcoEodModelsMachineProdResponse
 */
export interface EodMelcoEodModelsMachineProdResponse {
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsMachineProdResponse
     */
    url?: string | null;
}

export function EodMelcoEodModelsMachineProdResponseFromJSON(json: any): EodMelcoEodModelsMachineProdResponse {
    return EodMelcoEodModelsMachineProdResponseFromJSONTyped(json, false);
}

export function EodMelcoEodModelsMachineProdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoEodModelsMachineProdResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function EodMelcoEodModelsMachineProdResponseToJSON(value?: EodMelcoEodModelsMachineProdResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}


